export class PasswordValidationModel {
  isPasswordValid: boolean = true;
  validationMessage: string = "";
  passwordStrength: any = [];
  passwordCriteria: string = "Please enter strong password" +
                              "<ul class='passwordCriteriaMsg'>"+
                              "<li>At least 8 characters long.</li>" +
                              "<li>At least 1 capital letter.</li>" +
                              "<li>At least 1 lowercase letter.</li>" +
                              "<li>At least 1 special character.</li>" +
                              "<li>At least 1 numeric character.</li>" +
                              "</ul>"; 
}
export class EmailValidationModel {
  isEmailIdValid: boolean = true;
  validationMessage: string = "";
  isEmailRequired: boolean = true;
}

export class WebSiteUrlValidationModel {
  isValid: boolean = true;
  validationMessage: string = ""; 
}
export class UserNameValidationModel {
  isValid: boolean = true;
  validationMessage: string = "";
}
export class CodeValidationModel {
  isValid: boolean = true;
  validationMessage: string = "";
}
